import { Injectable } from '@angular/core';
import { 
    ActivatedRouteSnapshot, 
    CanActivate, 
    Router, 
    RouterStateSnapshot } from '@angular/router';
    import { Observable } from 'rxjs';
    import { map, take } from 'rxjs/operators';
    import { AuthService } from './auth.service';


    @Injectable({
        providedIn: 'root'
      })
       export class AuthGuard implements CanActivate {
        constructor(
          

          private authService: AuthService,
          private router: Router
        ) {}
      
       canActivate(
          next: ActivatedRouteSnapshot,
          state: RouterStateSnapshot):  boolean {
            console.log(window.sessionStorage.getItem('userid'));
            if((state.url).indexOf('fccp') > -1)
            {
              if(window.sessionStorage.getItem('fccp_userid')!= null){
                return true;
               }
               else
               {
                 this.router.navigate(['/fccp/fccplogin']);
                 return false;
               }
            }
            else{
              if(window.sessionStorage.getItem('userid')!= null){
                return true;
               }
               
               else
               {
                 this.router.navigate(['/auth/login']);
                 return false;
               }
            }
            
        }
      }


